var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-main"},[_c('section',{staticClass:"content-section"},[_c('div',{staticClass:"content-wrap"},[_c('h1',{staticClass:"verification-title"},[_vm._v(_vm._s(_vm.$t('general.email_verification_in_progress')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }